import { ActionTypes as DataActionTypes } from '../../actions/data';
import { localisedDate, localisedTimeAgo } from '../../utils/format';
import { getArticlePath } from '../../utils/routes';
export const initialState = {};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DataActionTypes.ARTICLE_PAGE_DATA_HYDRATE:
        case DataActionTypes.ARTICLE_PAGE_DATA_REQUEST_SUCCESS: {
            const { articleId, data, languageId, now } = action.payload;
            if (!data)
                return state;
            const { article, relatedArticles } = data;
            if (!article)
                return state;
            return {
                ...state,
                [articleId]: filloutArticle({
                    article,
                    relatedArticles,
                    languageId,
                    now,
                }),
            };
        }
    }
    return state;
};
export default reducer;
function filloutArticle({ article, relatedArticles, languageId, now, }) {
    return {
        ...article,
        categoryId: article.category.id,
        path: getArticlePath({ languageId, slug: article.slug }),
        createdAgo: localisedDate(article.createdAt, { languageId }),
        createdAtLocal: localisedTimeAgo(now, article.createdAt, languageId),
        lastPublishedAgo: localisedTimeAgo(now, article.lastPublishedAt, languageId),
        lastPublishedAtLocal: localisedDate(article.lastPublishedAt, {
            languageId,
        }),
        relatedArticles: relatedArticles.results.map((r) => r.id),
    };
}
//# sourceMappingURL=articleFullCache.js.map